import './LearnMore.css';

function LearnMore(props) {
  return (
    <button
      className="section-button SLIDE"
      onClick={() => window.open(props.SectionsImg, "_blank")}
      hidden={!props.SectionsImg}
    >
      {'Learn More'}
    </button>
    // <></>
  );
}

export default LearnMore;
